module.exports = __webpack_public_path__ + "img/cgm.6698bbc1.svg";